// AUTO GENERATED FILE - Changes WILL be lost.
// pl - used as 'pl' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Kupon",
  "product.last60-row-single": "NBA Last 60",
  "product.sb-english-single": "Liga angielska",
  "product.sb-italian-single": "Liga włoska",
  "product.sb-greek-single": "Liga grecka",
  "product.sb-english-league": "Liga angielska",
  "product.sb-italian-league": "Liga włoska",
  "product.sb-greek-league": "Liga grecka",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Postaw zakład",
  "betslip.clear": "Wyczyść wszystko",
  "betslip.clearResult": "Wyczyść",
  "betslip.noSelections": "Dodaj zakłady",
  "betslip.notLoggedIn": "Zaloguj",
  "betslip.refresh": "Odśwież",
  "betslip.totalStake": "Stawka",
  "betslip.noHistoryData": "Brak informacji o zakładzie",
  "betslip.openBets": "Otwarte zakłady",
  "betslip.betHistory": "Historia zakładów",
  "betslip.betHistoryWon": "Wygrane",
  "betslip.betHistoryLost": "Przegrane",
  "loading.loading": "Ładowanie",
  "loading.account": "Ładowanie konta",
  "loading.league": "Ładowanie ligi",
  "loading.gameweeks": "Ładowanie kolejek",
  "loading.markets": "Ładowanie rynków",
  "loading.bethistory": "Ładowanie historii",
  "login.loginRequired": "Logowanie wymagane",
  "login.loginToBet": "Proszę się zalogować",
  "navigation.back": "Powrót",
  "navigation.close": "Zamknij",
  "video.liveStreamAvailable": "Dostępne video",
  "video.logInToWatch": "Proszę się zalogować, aby oglądać",
  "error.error": "Błąd",
  "error.404": "Strona nie znaleziona",
  "error.gameLaunchFailed": "Nie można uruchomić gry",
  "error.unknownErrorCode": "Nieznany błąd: {code}",
  "error.minUnitStakeLimitExceeded": "Minimalna stawka wynosi {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksymalna stawka wynosi {limit}",
  "error.minTotalStakeLimitExceeded": "Minimalna stawka wynosi {limit}",
  "error.maxTotalStakeLimitExceeded": "Maksymalna stawka wynosi {limit}",
  "error.stakeInvalidMultiple": "Stawka musi być wielokrotnością {multiple}",
  "error.notPlaced": "Zakład odrzucony",
  "error.wagerDisallowed": "Niedozwolony zakład",
  "error.errorEventIsOff": "Zdarzenie się rozpoczeło",
  "multiplebet.Singles": "Singiel",
  "multiplebet.Doubles": "Duble",
  "multiplebet.Trebles": "Treble",
  "multiplebet.Accumulator": "Multi",
  "multiplebet.Perm 4-Folds": "Sys. 4-zdarzenia",
  "multiplebet.Perm 5-Folds": "Sys. 5-zdarzeń",
  "multiplebet.Perm 6-Folds": "Sys. 6-zdarzeń",
  "multiplebet.Perm 7-Folds": "Sys. 7-zdarzeń",
  "multiplebet.Perm 8-Folds": "Sys. 8-zdarzeń",
  "multiplebet.Perm 9-Folds": "Sys. 9-zdarzeń",
  "error.excess_bets": "Przekroczono maksymalną liczbę zdarzeń: {limit}",
  "product.sb-turkish-league": "Liga turecka",
  "error.minBetslipLimitExceeded": "Minimalna stawka kuponu wynosi {limit}.",
  "error.maxBetslipLimitExceeded": "Maksymalna stawka kuponu wynosi {limit}.",
  "error.exceededMaxPayout": "Maksymalna wygrana wynosi {limit}; proszę zmniejszyć stawkę.",
  "betslip.potentialReturns": "Potencjalna wygrana",
  "error.maintenanceEnabled": "Obecnie trwają prace konserwacyjne.",
  "error.internalError": "Błąd wewnętrzny.",
  "error.invalidSession": "Sesja jest nieważna.",
  "error.accountDisabled": "Konto jest nieaktywne.",
  "error.invalidPlayerID": "Nieprawidłowy identyfikator gracza.",
  "error.insufficientBalance": "Niewystarczająca ilość środków.",
  "error.configError": "Błąd konfiguracji",
  "error.betPlaceFailed": "Nie udało się postawić zakładu.",
  "error.invalidProductID": "Nieprawidłowy identyfikator produktu.",
  "error.playerReachedGamingLimits": "Przekroczono limit odpowiedzialnej gry.",
  "error.gameCycleDoesNotExist": "Runda nie istnieje",
  "error.betAmountLimitExceeded": "Przekroczono potencjalną kwotę wygranej dla niezweryfikowanego gracza.",
  "betslip.netStake": "Wkład",
  "betslip.tax": "Podatek",
  "error.badReturns": "Potencjalna wygrana niższa niż stawka",
  "betslip.taxDisclaimerPoland": "Wygrana zostanie pomniejszona o 10% w przypadku kwoty powyżej 2 280zł.",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATENY",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLIMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIA",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Koniec zakładów",
  "playtime": "Czas gry",
  "gameId": "ID gry",
  "noGames": "Brak dostępnych gier. Sprawdź wkrótce.",
  "Home": "Gospodarze",
  "Away": "Goście",
  "Visitor": "Goście",
  "rules": "Zasady",
  "soccerbet.gameWeek": "KOLEJKA",
  "soccerbet.noGameWeeks": "Brak dostępnych tygodni gry. Sprawdź wkrótce.",
  "soccerbet.league": "Tabele ligowe",
  "soccerbet.table.name": "Nazwa",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "R",
  "soccerbet.table.lost": "P",
  "soccerbet.table.points": "PKT",
  "market.abbr.Both Teams To Score": "OBIE DRUŻYNY STRZELĄ GOLA",
  "market.Both Teams To Score": "Obie drużyny strzelą gola",
  "market.Over / Under": "Powyżej/Poniżej",
  "market.Double Chance": "Podwójna szansa",
  "market.Match Result": "Mecz",
  "market.Exact Goals": "Dokładna liczba goli",
  "market.Correct Score": "Dokładny wynik",
  "market.Match Result Both Score": "Mecz & obie drużyny strzelą gola",
  "market.Result Und/Over 1.5 Total Goals": "Mecz & powyżej/poniżej 1.5 gola",
  "market.Result Und/Over 2.5 Total Goals": "Mecz & powyżej/poniżej 2.5 gola",
  "market.Under Over 1.5 Total Goals": "Powyżej/poniżej 1.5 gola",
  "market.Under Over 2.5 Total Goals": "Powyżej/poniżej 2.5 gola",
  "market.Under Over 3.5 Total Goals": "Powyżej/poniżej 3.5 gola",
  "market.Under Over 4.5 Total Goals": "Powyżej/poniżej 4.5 gola",
  "market.Total Goals 1 To 2": "Przedział goli 1-2",
  "market.Total Goals 1 To 3": "Przedział goli 1-3",
  "market.Total Goals 1 To 4": "Przedział goli 1-4",
  "market.Total Goals 2 To 3": "Przedział goli 2-3",
  "market.Total Goals 2 To 4": "Przedział goli 2-4",
  "market.Under Over 1.5 Home Goals": "Gospodarze - powyżej/poniżej 1.5 gola",
  "market.Under Over 1.5 Away Goals": "Goście - powyżej/poniżej 1.5 gola",
  "market.Home Team Exact Goals": "Gospodarze - dokładna liczba goli",
  "market.Away Team Exact Goals": "Goście - dokładna liczba goli",
  "selection.Yes": "Tak",
  "selection.No": "Nie",
  "selection.1+G": "1&tak",
  "selection.1+Ng": "1&nie",
  "selection.X+G": "X&tak",
  "selection.X+Ng": "X&nie",
  "selection.2+G": "2&tak",
  "selection.2+Ng": "2&nie",
  "selection.1+Yes": "1&tak",
  "selection.1+No": "1&nie",
  "selection.X+Yes": "X&tak",
  "selection.X+No": "X&nie",
  "selection.2+Yes": "2&tak",
  "selection.2+No": "2&nie",
  "selection.TID_ANY_GOAL_SCORED_YES": "Tak",
  "selection.TID_ANY_GOAL_SCORED_NO": "Nie",
  "selection.U": "Poniżej",
  "selection.O": "Powyżej",
  "selection.1+O": "1 & powyżej",
  "selection.X+O": "X & powyżej",
  "selection.2+O": "2 & powyżej",
  "selection.1+U": "1 & poniżej",
  "selection.X+U": "X & poniżej",
  "selection.2+U": "2 & poniżej",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "POWYŻEJ",
  "selection.Under": "PONIŻEJ",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZOSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSAPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SVASPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "C. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "sb-turkish.team.abbr.AKB": "AKB",
  "sb-turkish.team.abbr.BES": "BES",
  "sb-turkish.team.abbr.FEN": "FEN",
  "sb-turkish.team.abbr.GAL": "GAL",
  "sb-turkish.team.abbr.TRA": "TRA",
  "sb-turkish.team.abbr.ANT": "ANT",
  "sb-turkish.team.abbr.GEN": "GEN",
  "sb-turkish.team.abbr.KAS": "KAS",
  "sb-turkish.team.abbr.BUR": "RZEP",
  "sb-turkish.team.abbr.KAY": "KAY",
  "sb-turkish.team.abbr.SIV": "SIV",
  "sb-turkish.team.abbr.IBA": "IBA",
  "sb-turkish.team.abbr.HAT": "HAT",
  "sb-turkish.team.abbr.ADS": "ADS",
  "sb-turkish.team.abbr.ALT": "ALT",
  "sb-turkish.team.abbr.GAZ": "GAZ",
  "sb-turkish.team.abbr.GOZ": "GOZ",
  "sb-turkish.team.abbr.KON": "KON",
  "sb-turkish.team.abbr.CRS": "KSR",
  "sb-turkish.team.abbr.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "sb-english.team.abbr.BRE": "BRE",
  "sb-english.team.NOT": "Las Nottingham",
  "sb-english.team.abbr.NOT": "NIE",
  "market.Overall Winner": "Zwycięzca meczu",
  "market.Last60 Winner": "Zwycięzca (Last 60)",
  "market.Both Teams Over 2.5 Last60": "Obie drużyny powyżej 2.5 pkt (Last 60)",
  "market.Both Teams Over 3.5 Last60": "Obie drużyny powyżej 3.5 pkt (Last 60)",
  "market.First Team To Score In Last60": "Kto pierwszy zdobędzie punkty (Last 60)",
  "market.Last60 Winner And Winning Margin": "Zwycięzca & różnica zwycięstwa (Last 60)",
  "market.First To Score 4 Points Last60": "Kto pierwszy zdobędzie 4 pkt (Last 60)",
  "market.Home Under/Over 4.5 Last60": "{home} - powyżej/poniżej 4.5 pkt (Last 60)",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} - powyżej/poniżej 4.5 pkt (Last 60)",
  "market.Home Under/Over 5.5 Last60": "{home} - powyżej/poniżej 5.5 pkt (Last 60)",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} - powyżej/poniżej 5.5 pkt (Last 60)",
  "market.Last60 Winner And O/U 11.5": "Zwycięzca & powyżej/poniżej 11.5 pkt (LAST 60)",
  "market.Last60 Points Difference": "Różnica zwycięstwa (Last 60)",
  "market.Total 3-Pointers Last60": "Liczba trafionych rzutów za 3 pkt",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} & 10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} & Powyżej",
  "selection.Home & Under": "{home} & Poniżej",
  "selection.Visitor & Over": "{visitor} & Powyżej",
  "selection.Visitor & Under": "{visitor} & Poniżej",
  "last60.team.ATL": "Atlanta Hawks",
  "last60.team.BKN": "Brooklyn Nets",
  "last60.team.BOS": "Boston Celtics",
  "last60.team.CHA": "Charlotte Hornets",
  "last60.team.CHI": "Chicago Bulls",
  "last60.team.CLE": "Cleveland Cavaliers",
  "last60.team.DAL": "Dallas Mavericks",
  "last60.team.DEN": "Denver Nuggets",
  "last60.team.DET": "Detroit Pistons",
  "last60.team.GSW": "Golden State Warriors",
  "last60.team.HOU": "Houston Rockets",
  "last60.team.IND": "Indiana Pacers",
  "last60.team.LAC": "LA Clippers",
  "last60.team.LAL": "Los Angeles Lakers",
  "last60.team.MEM": "Memphis Grizzlies",
  "last60.team.MIA": "Miami Heat",
  "last60.team.MIL": "Milwaukee Bucks",
  "last60.team.MIN": "Minnesota Timberwolves",
  "last60.team.NOP": "New Orleans Pelicans",
  "last60.team.NYK": "New York Knicks",
  "last60.team.OKC": "Oklahoma City Thunder",
  "last60.team.ORL": "Orlando Magic",
  "last60.team.PHI": "Philadelphia 76ers",
  "last60.team.PHX": "Phoenix Suns",
  "last60.team.POR": "Portland Trail Blazers",
  "last60.team.SAC": "Sacramento Kings",
  "last60.team.SAS": "San Antonio Spurs",
  "last60.team.TOR": "Toronto Raptors",
  "last60.team.UTA": "Utah Jazz",
  "last60.team.WAS": "Washington Wizards",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "OL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}",
  "market.Total 3-Pointers Last60 1-6": "Liczba trafionych rzutów za 3 pkt (Last 60)",
  "market.Last60 Winning Margin 1": "Różnica zwycięstwa (Last 60)",
  "market.Last60 Winning Margin 2": "Różnica zwycięstwa (Last 60)",
  "market.Last60 Winning Margin 3": "Różnica zwycięstwa (Last 60)",
  "market.Last60 Winner & Winning Margin 1": "Zwycięzca & różnica zwycięstwa (Last 60)",
  "market.Last60 Winner & Winning Margin 2": "Zwycięzca & różnica zwycięstwa (Last 60)",
  "market.Last60 Winner & Winning Margin 3": "Zwycięzca & różnica zwycięstwa (Last 60)",
  "market.Total 3-Pointers Last60 1-3+": "Liczba trafionych rzutów za 3 pkt (Last 60)",
  "selection.Home & 1": "{home} & 1",
  "selection.Home & 2": "{home} & 2",
  "selection.Home & 3": "{home} & 3",
  "selection.Home & 4": "{home} & 4",
  "selection.Home & 5": "{home} & 5",
  "selection.Home & 6": "{home} & 6",
  "selection.Home & 7": "{home} & 7",
  "selection.Home & 8": "{home} & 8",
  "selection.Home & 9": "{home} & 9",
  "selection.Home & 10": "{home} & 10",
  "selection.Home & 11": "{home} & 11",
  "selection.Home & 12": "{home} & 12",
  "selection.Home & 13": "{home} & 13",
  "selection.Home & 14": "{home} & 14",
  "selection.Home & 15": "{home} & 15",
  "selection.Home & 16": "{home} & 16",
  "selection.Home & 17+": "{home} & 17+",
  "selection.Visitor & 1": "{visitor} & 1",
  "selection.Visitor & 2": "{visitor} & 2",
  "selection.Visitor & 3": "{visitor} & 3",
  "selection.Visitor & 4": "{visitor} & 4",
  "selection.Visitor & 5": "{visitor} & 5",
  "selection.Visitor & 6": "{visitor} & 6",
  "selection.Visitor & 7": "{visitor} & 7",
  "selection.Visitor & 8": "{visitor} & 8",
  "selection.Visitor & 9": "{visitor} & 9",
  "selection.Visitor & 10": "{visitor} & 10",
  "selection.Visitor & 11": "{visitor} & 11",
  "selection.Visitor & 12": "{visitor} & 12",
  "selection.Visitor & 13": "{visitor} & 13",
  "selection.Visitor & 14": "{visitor} & 14",
  "selection.Visitor & 15": "{visitor} & 15",
  "selection.Visitor & 16": "{visitor} & 16",
  "selection.Visitor & 17+": "{visitor} & 17+",
  "selection.Home & 1-2": "{home} & 1-2",
  "selection.Home & 3-4": "{home} & 3-4",
  "selection.Home & 5-6": "{home} & 5-6",
  "selection.Home & 7-8": "{home} & 7-8",
  "selection.Home & 9-10": "{home} & 9-10",
  "selection.Home & 11-12": "{home} & 11-12",
  "selection.Home & 13-14": "{home} & 13-14",
  "selection.Home & 15-16": "{home} & 15-16",
  "selection.Visitor & 1-2": "{visitor} & 1-2",
  "selection.Visitor & 3-4": "{visitor} & 3-4",
  "selection.Visitor & 5-6": "{visitor} & 5-6",
  "selection.Visitor & 7-8": "{visitor} & 7-8",
  "selection.Visitor & 9-10": "{visitor} & 9-10",
  "selection.Visitor & 11-12": "{visitor} & 11-12",
  "selection.Visitor & 13-14": "{visitor} & 13-14",
  "selection.Visitor & 15-16": "{visitor} & 15-16"
}
